import React, { useState, useEffect, useContext, forwardRef, useImperativeHandle } from "react";
import { ethers } from "ethers";
import { AppContext } from "./../../AppContext";

const UsdceBalanceFetcher = forwardRef(({ onUsdceBalance }, ref) => {
  const { rpcUrl, contractAddress } = useContext(AppContext);
  const [usdceBalance, setUsdceBalance] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const erc20ABI = [
    "function balanceOf(address account) view returns (uint256)",
  ];

  const usdc_e = "0xA7D7079b0FEaD91F3e65f86E8915Cb59c1a4C664"; // USDC address

  // Fetch the USDC balance of the JakobWallet contract
  const fetchUsdcBalance = async () => {
    if (!usdc_e) return;
    setIsLoading(true);
    try {
      const provider = new ethers.providers.JsonRpcProvider(rpcUrl);
      const usdcContract = new ethers.Contract(usdc_e, erc20ABI, provider);
      const balance = await usdcContract.balanceOf(contractAddress);
      const formattedBalance = Number(ethers.utils.formatUnits(balance, 6)).toFixed(2); // Format to 2 decimals
      setUsdceBalance(formattedBalance);

      // Pass the formatted balance up to the parent component
      onUsdceBalance(formattedBalance);
    } catch (error) {
      console.error("Error fetching USDC balance:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Expose fetchUsdcBalance as a method via the ref
  useImperativeHandle(ref, () => ({
    reloadBalance: fetchUsdcBalance,
  }));

  useEffect(() => {
    // Initial fetch when component mounts
    fetchUsdcBalance();
  }, []);

  return (
    <>
      {/* Uncomment if you need to display a UI for fetching the balance */}
      {/* <VStack spacing={4} w="100%" p={4} alignItems="center">
        <Box p={4} border="1px solid" borderRadius="md" bg="gray.50" width="100%">
          <Text fontSize="lg" fontWeight="bold">
            USDC Balance
          </Text>
          <Text fontSize="md">
            {usdceBalance !== null ? `${usdceBalance} USDC` : "Balance not available"}
          </Text>
        </Box>
        <Button
          colorScheme="teal"
          onClick={fetchUsdcBalance}
          isLoading={isLoading}
          loadingText="Fetching Balance"
        >
          Refresh USDC Balance
        </Button>
      </VStack> */}
    </>
  );
});

export default UsdceBalanceFetcher;
